import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-lock\"><g fill=\"currentColor\"><path d=\"M4.286 9.786a.857.857 0 00-.857.857v8.571c0 .474.383.857.857.857h15.428a.857.857 0 00.857-.857v-8.571a.857.857 0 00-.857-.857H4.286zm0-1.715h15.428a2.571 2.571 0 012.572 2.572v8.571a2.571 2.571 0 01-2.572 2.572H4.286a2.571 2.571 0 01-2.572-2.572v-8.571A2.571 2.571 0 014.286 8.07z\" /><path d=\"M17.143 8.071h-1.714V6.464c0-1.952-1.535-3.535-3.429-3.535S8.571 4.512 8.571 6.464v1.607H6.857v-1.5c0-2.958 2.303-5.357 5.143-5.357s5.143 2.399 5.143 5.357v1.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol